import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { flowTextField } from '../textfield/textField.theme';
import { flowInputBase } from '../textfield/inputBase.theme';
import { flowInput } from '../textfield/input.theme';
import { flowOutlinedInput } from '../textfield/outlinedInput.theme';
import { flowFilledInput } from '../textfield/filledInput.theme';

export const flowPickersTextField: Components<Theme>['MuiPickersTextField'] = {
  defaultProps: {
    variant: 'filled',
  },
  styleOverrides: { ...flowTextField.styleOverrides } as Components<Theme>['MuiPickersTextField']['styleOverrides'],
};
export const flowPickersInputBase: Components<Theme>['MuiPickersInputBase'] = {
  ...(flowInputBase as Components<Theme>['MuiPickersInputBase']),
};
export const flowPickersInput: Components<Theme>['MuiPickersInput'] = {
  ...(flowInput as Components<Theme>['MuiPickersInput']),
};
export const flowPickersOutlinedInput: Components<Theme>['MuiPickersOutlinedInput'] = {
  ...(flowOutlinedInput as Components<Theme>['MuiPickersOutlinedInput']),
};
export const flowPickersFilledInput: Components<Theme>['MuiPickersFilledInput'] = {
  ...(flowFilledInput as Components<Theme>['MuiPickersFilledInput']),
};
